const extractLozengeActionItems = response => {
  var _response$transitions, _response$transitions2;
  const items = (_response$transitions = response === null || response === void 0 ? void 0 : (_response$transitions2 = response.transitions) === null || _response$transitions2 === void 0 ? void 0 : _response$transitions2.map(({
    appearance,
    id,
    name
  }) => {
    var _ref;
    return {
      appearance: (_ref = appearance) !== null && _ref !== void 0 ? _ref : 'default',
      id,
      text: name
    };
  })) !== null && _response$transitions !== void 0 ? _response$transitions : [];
  return items.sort((a, b) => a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
export default extractLozengeActionItems;